// src/utils/safeStorage.js
// sessionStorage access that never throws. Some mobile in-app browsers and
// privacy-hardened contexts (storage partitioning, "block third-party storage")
// throw a SecurityError just from touching window.sessionStorage — including
// when read synchronously during render (e.g. a useState lazy initializer),
// which crashes the whole page since there's no error boundary around it.
export const safeSessionStorage = {
  getItem(key) {
    try {
      return sessionStorage.getItem(key);
    } catch (_) {
      return null;
    }
  },
  setItem(key, value) {
    try {
      sessionStorage.setItem(key, value);
    } catch (_) { /* storage blocked/unavailable — continue without persistence */ }
  },
  removeItem(key) {
    try {
      sessionStorage.removeItem(key);
    } catch (_) { /* ignore */ }
  },
};

// Same reasoning, for localStorage — the property getter itself throws in the
// same contexts (confirmed in production: a buyer opening a download link
// from Gmail's Android in-app browser hit this exact SecurityError inside a
// useState lazy initializer on /download/:token, which crashed the page
// before it ever rendered, on the first attempt to receive a paid file).
export const safeLocalStorage = {
  getItem(key) {
    try {
      return localStorage.getItem(key);
    } catch (_) {
      return null;
    }
  },
  setItem(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (_) { /* storage blocked/unavailable — continue without persistence */ }
  },
  removeItem(key) {
    try {
      localStorage.removeItem(key);
    } catch (_) { /* ignore */ }
  },
};
